import { render, staticRenderFns } from "./customer_screen.vue?vue&type=template&id=05767e5f&scoped=true&"
import script from "./customer_screen.vue?vue&type=script&lang=js&"
export * from "./customer_screen.vue?vue&type=script&lang=js&"
import style0 from "./customer_screen.vue?vue&type=style&index=0&id=05767e5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05767e5f",
  null
  
)

export default component.exports